// extracted by mini-css-extract-plugin
export default {"svgLegendContainer":"ChartPropProvider_svgLegendContainer__rbWgy","svgLegendContent":"ChartPropProvider_svgLegendContent__5UpT8"};